module.exports = __tmimport("~endpoint:{controller: \'customized/shop\', action: \'cms_page\', slug: \':slug\'}");